// Google Analytics (GA4) helper — single global install in /public/index.html.
//
// Usage:
//   import { trackEvent, EVENTS } from "../lib/analytics";
//   trackEvent(EVENTS.SUBJECT_ADDED, { subject_id });
//
// All calls degrade silently if gtag isn't loaded (e.g. blocked by adblock or
// during SSR/tests). Route-change tracking is wired separately via the
// RouteAnalytics component mounted near the top of the React tree.

const MEASUREMENT_ID = "G-DDVRQ91SZY";

export const EVENTS = Object.freeze({
  SIGNUP_COMPLETED:               "signup_completed",
  TRIAL_STARTED:                  "trial_started",
  SUBJECT_ADDED:                  "subject_added",
  CHAPTER_ADDED:                  "chapter_added",
  TIMER_SAVED:                    "timer_saved",
  MOCK_TEST_CREATED:              "mock_test_created",
  PREMIUM_PAGE_OPENED:            "premium_page_opened",
  PREMIUM_PURCHASED:              "premium_purchased",
  COMMUNITY_OPENED:               "community_opened",
  FRIEND_ADDED:                   "friend_added",
  ACCOUNT_DELETED:                "account_deleted",
  // Founder's Reward Campaign (Jun 2026)
  FOUNDERS_REWARD_GRANTED:        "founders_reward_granted",
  FOUNDERS_REWARD_POPUP_SHOWN:    "founders_reward_popup_shown",
  FOUNDERS_REWARD_POPUP_DISMISSED:"founders_reward_popup_dismissed",
  PREMIUM_TRIAL_30D_STARTED:      "premium_trial_30d_started",
  PREMIUM_EXPIRY_WARNING_SHOWN:   "premium_expiry_warning_shown",
  PREMIUM_EXPIRY_WARNING_DISMISSED:"premium_expiry_warning_dismissed",
  PREMIUM_UPGRADE_CLICKED:        "premium_upgrade_clicked",
});

function _gtag(...args) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try { window.gtag(...args); } catch { /* ignore */ }
}

/**
 * Fire a custom GA4 event.
 * @param {string} name   The event name (use EVENTS.* constants).
 * @param {object} params Optional extra parameters (small, JSON-safe).
 */
export function trackEvent(name, params = {}) {
  if (!name) return;
  _gtag("event", name, params);
}

/**
 * Manually emit a page_view for SPA route changes. Call from a location
 * effect — see RouteAnalytics.
 * @param {string} path   The pathname + search (e.g. "/dashboard?tab=foo").
 * @param {string} title  Optional page title (defaults to document.title).
 */
export function trackPageView(path, title) {
  if (!path) return;
  _gtag("event", "page_view", {
    page_path: path,
    page_location: typeof window !== "undefined" ? window.location.href : "",
    page_title: title || (typeof document !== "undefined" ? document.title : ""),
    send_to: MEASUREMENT_ID,
  });
}
